"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticService = void 0;
var axiosHelper_1 = __importDefault(require("./apis/axiosHelper"));
var storageService_1 = require("./storageService");
function analyticService(serviceConfig) {
    var baseURL = serviceConfig.baseURL, eventUrl = serviceConfig.eventUrl, appName = serviceConfig.appName, _a = serviceConfig.appType, appType = _a === void 0 ? 'web' : _a, storeName = serviceConfig.storeName, _b = serviceConfig.eventStoreKey, eventStoreKey = _b === void 0 ? 'eventData' : _b, headers = serviceConfig.headers, timeout = serviceConfig.timeout, _c = serviceConfig.cacheTime, cacheTime = _c === void 0 ? 5 : _c, // 5mins
    _d = serviceConfig.retries, // 5mins
    retries = _d === void 0 ? 3 : _d, _e = serviceConfig.retriesDelay, retriesDelay = _e === void 0 ? 3 : _e, _f = serviceConfig.cacheSize, cacheSize = _f === void 0 ? 3 : _f;
    var eventData = [];
    var cacheTimeoutRef;
    var isEventSending = false;
    var cacheTimeInSec = 60000 * cacheTime;
    var lfStore = new storageService_1.StorageService({ name: appName, appType: appType, storeName: storeName });
    var axiosClientInstance = new axiosHelper_1.default({ baseURL: baseURL, timeout: timeout, headers: headers, retries: retries, retriesDelay: retriesDelay });
    function event(data) {
        eventData.push(data);
        lfStore.putEvent(eventStoreKey, eventData);
        if (eventData.length > cacheSize)
            sendEvents(eventData);
        if (!cacheTimeoutRef)
            resetCacheTimeout();
    }
    function sendEvents(data) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, submitted, sendEventsCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(data, 'sendEvents-data');
                        if (isEventSending)
                            return [2 /*return*/];
                        isEventSending = true;
                        payload = Object.assign([], data);
                        return [4 /*yield*/, axiosClientInstance.makePostRequest({
                                url: eventUrl,
                                data: payload
                            })];
                    case 1:
                        submitted = (_a.sent()).submitted;
                        if (submitted) {
                            sendEventsCount = payload.length;
                            console.log(sendEventsCount, payload, 'sendEventsCount');
                            // case 1: no event is fired when send event api is in pending state
                            if (sendEventsCount === eventData.length) {
                                eventData.length = 0;
                                if (cacheTimeoutRef)
                                    clearTimeout(cacheTimeoutRef);
                                cacheTimeoutRef = null;
                            }
                            else {
                                // case 2: some event is fired when send event api is in pending state
                                eventData.splice(0, sendEventsCount);
                                resetCacheTimeout();
                            }
                            lfStore.putEvent(eventStoreKey, eventData);
                        }
                        isEventSending = false;
                        return [2 /*return*/];
                }
            });
        });
    }
    function resetCacheTimeout() {
        if (cacheTimeoutRef)
            clearTimeout(cacheTimeoutRef);
        cacheTimeoutRef = setTimeout(function () {
            if (eventData.length)
                sendEvents(eventData);
            else
                cacheTimeoutRef = null;
        }, cacheTimeInSec);
    }
    function init() {
        lfStore.getEvent(eventStoreKey).then(function (value) {
            console.log(value, 'value');
            if (value) {
                eventData = value;
                if (eventData.length > cacheSize)
                    sendEvents(eventData);
                else
                    resetCacheTimeout();
            }
        });
    }
    init();
    return {
        event: event
    };
}
exports.analyticService = analyticService;
